/** AK-47, as a thing you can carry. The gun itself is `sim/weapons/guns/ak47.ts`. */

import { NO_ARMOR } from '@/sim/combat/armorMitigation';
import type { WeaponItem } from '@/sim/items/itemContract';

export const AK47_ITEM = {
  id: 'ak47',
  kind: 'weapon',
  label: 'AK-47',
  description:
    'Wood, steel and 7.62. Hits harder than the M4, climbs harder, works after a week in the mud.',
  rarity: 'uncommon',
  weightKg: 4.3,
  stackLimit: 1,
  equip: {
    slots: ['primaryWeapon'],
    statDeltas: {},
    armor: NO_ARMOR,
    damageModifiers: [],
  },
  weaponId: 'ak47',
} as const satisfies WeaponItem;
